import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { IdlService } from 'src/app/core/service/idl.service';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { AuthService } from 'src/app/helper/service/auth.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { SocketService } from './service/socket.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { LicensePageComponent } from '../license-page/license-page.component';
import { ResponseData } from 'src/app/helper/interface/response';
import { AuthApiService } from 'src/app/core/service/auth-api.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  providers: [
    IdlService
  ]
})
export class DefaultComponent implements OnInit, OnDestroy {
  imagepath = ''
  @ViewChild('licensePage') licensePage: LicensePageComponent | undefined
  max: any;
  windowValue: boolean | undefined;
  public modalRef!: BsModalRef;
  @ViewChild('childModal', { static: false }) childModal!: ModalDirective;
  licenseChecked: any = false;
  userName: any;
  licenseCheckedVlaue: boolean | undefined;
  licenseCheckedRenew: boolean | undefined;
  settingdata: any;
  constructor(private idlService: IdlService, private auth: AuthService,
    private socketServe: SocketService,
    private dashServ: DashboardService,
    private modalService: ModalService, private authApi: AuthApiService) { }

  ngOnDestroy(): void {
    this.idlService.ngOnDestroy();
  }
  ngOnInit(): void {

    // this.getSettingData()
    this.auth.currentSetting.subscribe(res => {
      if (+res.idl_timeout) {
        this.initTimer(+res.idl_timeout)
      }
    })
    if (window.innerWidth > 425) {
      this.windowValue = true;
    } else {
      this.windowValue = false;
    }
    // this.socketServe.initSocket();
    this.dashServ?.initSub();
  }
  getSettingData() {
    this.authApi.getSetting().then((res: ResponseData) => {
      this.imagepath = res.result.logo_path
      // this.settingdata = res.result.license[0].expire_date
      if (new Date(this.settingdata) > new Date()) {
        //  this.licenseChecked=true;   
      }
      //  return res.result.license[0].expire_date
    })
  }

  licenceValue(a) {
    this.licenseChecked = a;
  }
  initTimer(firstTimerValue: number, secondTimerValue: number = 30): void {
    // Timer value initialization
    this.idlService.USER_IDLE_TIMER_VALUE_IN_MIN = firstTimerValue;
    this.idlService.FINAL_LEVEL_TIMER_VALUE_IN_MIN = secondTimerValue;
    // end

    // Watcher on timer
    this.idlService.initilizeSessionTimeout();
    // this.idlService.userIdlenessChecker.subscribe((status: string) => {
    //   this.initiateFirstTimer(status);
    // });

    this.idlService.secondLevelUserIdleChecker.subscribe((status: string) => {
      this.initiateSecondTimer(status);
    });
  }
  secondTimerLeft: any = 0;
  initiateSecondTimer = (status: string) => {
    console.log('timer status ', status)
    switch (status) {
      case 'INITIATE_SECOND_TIMER':
        break;

      case 'SECOND_TIMER_STARTED':
        //show modal
        this.openModal();
        break;

      case 'SECOND_TIMER_STOPPED':
        this.logout();
        break;

      default:
        this.secondTimerLeft = status;
        break;
    }
  }
  logout() {
    if (!isEmptyObj(this.childModal)) { this.childModal.hide(); }
    this.auth.logout()
  }
  continue(): void {
    // stop second timer and initiate first timer again
    IdlService.runSecondTimer = false;
    this.idlService.initilizeSessionTimeout();
    if (!isEmptyObj(this.childModal)) { this.childModal.hide(); }
  }
  openModal() {
    this.modalService?.close();
    const initialState: any = {
      animated: false,
      backdrop: "static",
      keyboard: false,
      id: 'CONFIRM_BOX'
    };
    this.childModal.config = initialState
    this.childModal.show();
  }

}
